import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export enum FlowStage {
  Login = 1,
  CreatePassword,
  UserInformation,
  CompanyInformation,
  ThankYou
}

export interface Flow {
  initialStage: FlowStage,
  stage: FlowStage,
}

const initialState: Flow = {
  initialStage: FlowStage.CreatePassword,
  stage: FlowStage.Login,
};

export const flowSlice = createSlice({
  name: 'flow',

  initialState,

  reducers: {
    setStage(state, action: PayloadAction<FlowStage>) {
      state.stage = action.payload;
      if (action.payload === FlowStage.Login || action.payload === FlowStage.CreatePassword) {
        state.initialStage = action.payload;
      }
    },
  },
});

export const flowActions = flowSlice.actions;
export type FlowSlice = {
  [flowSlice.name]: ReturnType<typeof flowSlice['reducer']>
};
